import React from 'react'
import { graphql, Link } from 'gatsby'
import style from './card.mod.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Button } from '@components'

const CardLinkWrapper = ({ children, to, ...props }) => {
  const isExternal = (to && to.indexOf('http') > -1) || false

  if (!to) {
    return <>{children}</>
  } else if (isExternal) {
    return (
      <a target="_blank" rel="noopener noreferrer" href={to} {...props}>
        {children}
      </a>
    )
  } else {
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    )
  }
}

const Card = props => {
  const {
    backgroundColour,
    bordered = false,
    button,
    link,
    buttonStyle = 'Secondary',
    unstyledButton = false,
    contained = false,
    description,
    elevated = false,
    heading,
    horizontal = false,
    image,
    horizontalImage,
    subheading,
    modifiers = []
  } = props
  const { gatsbyImageData, alt } = horizontal ? horizontalImage : image

  backgroundColour &&
    modifiers.push(
      `${
        style.card
      }--background-colour-${backgroundColour
        .toLowerCase()
        .replace(/ /gi, '-')}`
    )
  bordered && modifiers.push(`${style.card}--bordered`)
  contained && modifiers.push(`${style.card}--contained`)
  elevated && modifiers.push(`${style.card}--elevated`)
  horizontal && modifiers.push(`${style.card}--horizontal`)

  return (
    <CardLinkWrapper to={link?.link?.path || link?.url}>
      <div className={[style.card, ...modifiers].join(' ')}>
        <div className={style.card__image}>
          <GatsbyImage image={gatsbyImageData} alt={alt || ''} />
        </div>
        <div className={style.card__content}>
          {heading && (horizontal ? <h3>{heading}</h3> : <h4>{heading}</h4>)}
          {subheading && <p>{subheading}</p>}
          {description && (
            <div
              className={style.card__description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {(button?.link?.path || button?.url) && (
            <Button
              to={button?.link?.path || button.url}
              buttonStyle={buttonStyle}
              unstyled={unstyledButton}
              length={'large'}
            >
              {button.displayText}
            </Button>
          )}
        </div>
      </div>
    </CardLinkWrapper>
  )
}

export default Card

export { CardLinkWrapper }

export const query = graphql`
  fragment Card on DatoCmsCard {
    heading
    description
    button {
      ...Link
    }
    id
    image {
      gatsbyImageData(
        layout: FULL_WIDTH
        imgixParams: { h: "224", w: "364", fit: "crop", q: 60 }
      )
      alt
    }
  }

  fragment PageCard on DatoCmsPage {
    path
    id
    title
    excerpt
    horizontalImage: image {
      gatsbyImageData(
        layout: FULL_WIDTH
        imgixParams: { h: "400", w: "330", fit: "crop", q: 60 }
      )
      alt
    }
  }
`
